import React, { useRef, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./CreateApplication.module.scss";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
  Select,
  Table,
  Tooltip,
  Upload,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { custom_posts } from "../../data";
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { IApplicationRequest } from "../../types";
import type { TableColumnsType, UploadProps } from "antd";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  addMessage,
  createApplication,
  getApplicationsList,
  getBrokersApplicationsList,
  getPartnerCompanies,
  setActiveTab,
} from "../../redux/ApplicationSlice";
import { UploadFile } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import { Typography } from "antd";
const { Title } = Typography;
const { Option } = Select;

const props: UploadProps = {
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  onChange({ file, fileList }) {
    if (file.status !== "uploading") {
      console.log(file, fileList);
    }
  },
  beforeUpload: () => false,
  defaultFileList: [],
};

export interface UploadTableType {
  id: string;
  number?: number;
  name: string;
  upload_file?: string;
}

const CreateApplication2: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [form] = useForm();
  const navigate = useNavigate();
  const [files, setFiles] = useState<Record<string, UploadFile<any>[]>>({});
  const loading = useSelector((state: RootState) => state.application.loading);
  const user = useSelector((state: RootState) => state.user.user);
  const [api, contextHolder] = notification.useNotification();
  const [shipperCompanyId, setShiperCompanyId] = useState<number | null>(null);
  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };
  const dispatch: AppDispatch = useDispatch();
  const [phone, setPhone] = useState(user?.phone);
  const [isRailwayCarriage, setIsRailwayCarriage] = useState<boolean>(false);
  const currentPage = useSelector(
    (state: RootState) => state.application.currentPage,
  );

  const countries = useSelector(
    (state: RootState) => state.application.countries,
  );
  const managerServices = useSelector(
    (state: RootState) => state.application.managerServices,
  );
  const addRouteRef = useRef<() => void>();

  const handleChange =
    (recordId: string) => (info: { fileList: UploadFile<any>[] }) => {
      setFiles((prev) => ({
        ...prev,
        [recordId]: info.fileList,
      }));
      form.setFieldsValue({
        [recordId]: info.fileList,
      });
    };

  const UploadTableColums: TableColumnsType<UploadTableType> = [
    { dataIndex: "number", title: "№", width: 50, align: "center" },
    { dataIndex: "name", title: t("Наименование документа"), width: 650 },
    {
      title: "Upload",
      dataIndex: "upload",
      render: (_: any, record: UploadTableType) => {
        return (
          <div className={s.table_upload}>
            <Form.Item
              name={record.id}
              rules={[
                {
                  validator: (_, value) =>
                    value && value.length > 0
                      ? Promise.resolve()
                      : Promise.reject(new Error(t("Загрузите файл"))),
                },
              ]}
            >
              <Upload
                {...props}
                beforeUpload={() => false}
                fileList={files[record.id] || []}
                onChange={handleChange(record.id)}
              >
                <Button icon={<UploadOutlined />} className={s.upload_btn}>
                  Upload
                </Button>
              </Upload>
            </Form.Item>
          </div>
        );
      },
    },
  ];

  const uploadTableData = [
    { id: "invoice", name: t("Инвойс (документ сопровождающий груз)") },
    {
      id: "customs_declaration_files",
      name: t("Экспортная/ Транзитная декларация"),
    },
    {
      id: "transport",
      name: t("Транспортный документ (CMR, Bill of Lading,...)"),
    },
    { id: "tech_passport_file", name: t("Техпаспорт") },
    { id: "drivers_passport", name: t("Паспорт водителя") },
    { id: "supporting", name: t("Прочая документация") },
  ];

  // const addApplication = async (values: IApplicationRequest) => {
  //   console.log("values", values);
  //   const routes = values.routes.map((it) => ({
  //     transit_country: it.transit_country,
  //     entry_customs_checkpoint: it.entry_customs_checkpoint,
  //     exit_customs_checkpoint: it.exit_customs_checkpoint,
  //     partner_company: it.partner_company,
  //     service: it.service,
  //     is_destination: !!it.is_destination,
  //   }));

  //   if (!routes.some((r) => r.is_destination)) {
  //     if (routes.length) routes[routes.length - 1].is_destination = true;
  //   }

  //   console.log("routes", routes);

  //   const data = new FormData();
  //   //data.append("application_type", "NCTS_declaration");
  //   // data.append("shipper_country", values.shipper_country);
  //   // data.append("destination_country", values.destination_country);
  //   // data.append("contact_phone", phone ?? "");
  //   // data.append("vehicle_number", values.vehicle_number);
  //   // values.contact_email !== undefined &&
  //   //   data.append("contact_email", values.contact_email);
  //   // // data.append("railway_carriage", isRailwayCarriage.toString());
  //   // data.append("container_number", values.container_number);
  //   // data.append("customs_seal_numbers", values.customs_seal_numbers);
  //   // data.append(
  //   //   "shipper_country_partner_company",
  //   //   values.shipper_country_partner_company
  //   // );
  //   // data.append("driver_name", values.driver_name);
  //   // data.append("routes", JSON.stringify(routes));

  //   // (Object.keys(values) as (keyof IApplicationRequest)[]).forEach((key) => {
  //   //   const value = values[key];
  //   //   if (value !== undefined && value !== null) {
  //   //     if (key === "routes") {
  //   //       data.append("routes", JSON.stringify(routes));
  //   //     } else {
  //   //       data.append(key, value as any);
  //   //     }
  //   //   }
  //   // });

  //   (Object.keys(values) as (keyof IApplicationRequest)[])
  //     .filter((key) => key !== "routes")
  //     .forEach((key) => {
  //       const value = values[key];
  //       if (value !== undefined && value !== null) {
  //         data.append(key, value as any);
  //       }
  //     });

  //   // добавляем routes один раз
  //   data.append("routes", JSON.stringify(routes));

  //   Object.entries(files).forEach(([fieldName, fileList]) => {
  //     fileList.forEach((fileItem) => {
  //       if (fileItem.originFileObj) {
  //         data.append(fieldName, fileItem.originFileObj);
  //       }
  //     });
  //   });

  //   try {
  //     const res = await dispatch(createApplication(data));
  //     if (res.type === "applications/createApplication/fulfilled") {
  //       openNotification(true, "Вы создали заявление!", "success")();
  //       dispatch(setActiveTab("myApplications"));
  //       dispatch(getApplicationsList(1));
  //       navigate("/brokersApplications");

  //       if (res.payload && "id" in res.payload) {
  //         await dispatch(
  //           addMessage({
  //             application: Number(res.payload.id),
  //             content: "Заявление успешно зарегистрированно!",
  //             application_status: "new",
  //           })
  //         );
  //       }

  //       // setTimeout(() => {
  //       //   if (user?.role === "broker") {
  //       //     navigate("/brokersApplications");
  //       //   } else {
  //       //     navigate("/applications");
  //       //   }
  //       // }, 1000);
  //       // form.resetFields();
  //     }
  //   } catch (error) {
  //     console.error("Failed to create application:", error);
  //   }
  // };

  const addApplication = async (values: IApplicationRequest) => {
    const selectedRoutes = values.routes.map((it) => ({
      transit_country: it.transit_country,
      entry_customs_checkpoint: it.entry_customs_checkpoint,

      partner_company: it.partner_company,
      service: it.service,
      is_destination: !!it.is_destination,
    }));

    const uniqueRoutes: typeof selectedRoutes = [];
    const seen = new Set<string>();
    selectedRoutes.forEach((r) => {
      const key = JSON.stringify(r);
      if (!seen.has(key)) {
        seen.add(key);
        uniqueRoutes.push(r);
      }
    });
    const finalRoutes = uniqueRoutes;
    if (!finalRoutes.some((r) => r.is_destination) && finalRoutes.length) {
      finalRoutes[finalRoutes.length - 1].is_destination = true;
    }

    if (
      !selectedRoutes.some((r) => r.is_destination) &&
      selectedRoutes.length
    ) {
      selectedRoutes[selectedRoutes.length - 1].is_destination = true;
    }

    const data = new FormData();

    (Object.keys(values) as (keyof IApplicationRequest)[])
      .filter((key) => key !== "routes")
      .forEach((key) => {
        const value = values[key];
        if (value !== undefined && value !== null) {
          data.append(key, value as any);
        }
      });

    // добавляем routes один раз
    data.append("routes", JSON.stringify(finalRoutes));

    // добавляем файлы
    Object.entries(files).forEach(([fieldName, fileList]) => {
      fileList.forEach((fileItem) => {
        if (fileItem.originFileObj) {
          data.append(fieldName, fileItem.originFileObj);
        }
      });
    });

    try {
      const res = await dispatch(createApplication(data));
      if (res.type === "applications/createApplication/fulfilled") {
        openNotification(true, "Вы создали заявление!", "success")();
        dispatch(setActiveTab("myApplications"));
        dispatch(getApplicationsList(1));
        navigate("/brokersApplications");

        if (res.payload && "id" in res.payload) {
          await dispatch(
            addMessage({
              application: Number(res.payload.id),
              content: "Заявление успешно зарегистрированно!",
              application_status: "new",
            }),
          );
        }
      }
    } catch (error) {
      console.error("Failed to create application:", error);
    }
  };

  return (
    <div className={s.wrapper}>
      {contextHolder}
      {width > 700 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <Link
          to={
            user?.role === "broker" ? "/brokersApplications" : "/applications"
          }
          className={s.back}
        >
          <ArrowLeftOutlined className={s.backIcon} /> {t("Назад")}
        </Link>
        <h2 className={s.h2}>{t("Зарегистрировать новую заявку")}</h2>
        <div className={s.form}>
          <Form
            layout="vertical"
            className={"create_application"}
            form={form}
            onFinish={addApplication}
          >
            <Row gutter={[12, 8]}>
              <Col span={width > 900 ? 4 : 24}>
                <Form.Item
                  name="shipper_country"
                  label={
                    <div className={s.bold}>{t("Страна грузоотправитель")}</div>
                  }
                  rules={[
                    {
                      required: true,
                      message: t("Выберите страну грузоотправителя"),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className={s.select}
                    placeholder={t("Выберите страну")}
                    options={countries?.map((it) => ({
                      value: it?.id,
                      label: it?.transit_country_name,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 4 : 24}>
                <Form.Item
                  name="vehicle_number"
                  label={t("№ транспортного средства")}
                  rules={[
                    {
                      required: true,
                      message: t("Введите № транспортного средства"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Введите № транспортного средства")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 4 : 20}>
                <Form.Item name="container_number" label={t("№ контейнера")}>
                  <Input
                    placeholder={t("Укажите № контейнера")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 9 : 24}>
                <Form.Item
                  name="customs_seal_numbers"
                  label={t("Номера таможенных пломб")}
                >
                  <TextArea
                    placeholder={t("Укажите номера таможенных пломб")}
                    className={s.input}
                    autoSize={{ minRows: 1, maxRows: 3 }}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item label=" ">
                  <button
                    type="button"
                    className={s.add_route_btn}
                    onClick={() => addRouteRef.current?.()}
                  >
                    <PlusCircleOutlined className={s.plus_icon} />
                    &nbsp;&nbsp; {t("Транзитная страна")}
                  </button>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[10, 4]}>
              <Form.List
                name="routes"
                initialValue={[{ is_destination: true }]}
              >
                {(fields, { add, remove }) => {
                  addRouteRef.current = () => {
                    const routes = form.getFieldValue("routes") || [];
                    const insertIndex = Math.max(0, routes.length - 1);

                    const newRoute = {
                      is_destination: false,
                      transit_country: undefined,
                      entry_customs_checkpoint: undefined,
                      exit_customs_checkpoint: undefined,
                      partner_company: undefined,
                      service: undefined,
                    };

                    const updated = [
                      ...routes.slice(0, insertIndex),
                      newRoute,
                      ...routes.slice(insertIndex),
                    ];

                    updated.forEach((r, i) => {
                      r.is_destination = i === updated.length - 1;
                    });

                    form.setFieldsValue({ routes: updated });
                  };

                  return (
                    <>
                      {fields.map(({ key, name, ...restField }) => {
                        const routes = form.getFieldValue("routes") || [];
                        const route = routes[name];
                        return (
                          <div
                            key={key}
                            className={
                              Array.isArray(fields) && fields?.length > 0
                                ? s.dynamic_fields
                                : ""
                            }
                          >
                            <div>
                              {" "}
                              <Title level={5} className={s.route_title}>
                                {route?.is_destination
                                  ? t("Страна грузополучателя")
                                  : t("Страна транзита")}
                              </Title>
                            </div>
                            <Col span={3}>
                              <Form.Item
                                {...restField}
                                name={[name, "transit_country"]}
                                label={t("Страна")}
                                rules={[
                                  {
                                    required: true,
                                    message: t("Страна транзита"),
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  className={s.select}
                                  placeholder={t("Выберите страну")}
                                  options={countries?.map((it) => ({
                                    value: it?.id,
                                    label: it?.transit_country_name,
                                  }))}
                                  onChange={(value) => {
                                    const country = managerServices?.find(
                                      (c) => c.id === value,
                                    );
                                    const managerId =
                                      country?.manager?.id ?? undefined;

                                    form.setFieldValue(["routes", name], {
                                      transit_country: value,
                                      partner_company: managerId,
                                      service: undefined,
                                    });
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={5}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.routes?.[name]?.transit_country !==
                                  currentValues.routes?.[name]?.transit_country
                                }
                              >
                                {({ getFieldValue }) => {
                                  const routes = (getFieldValue("routes") ||
                                    []) as any[];
                                  const route = routes[name];
                                  const selectedCountryId =
                                    route?.transit_country;

                                  const country = managerServices?.find(
                                    (c) => c.id === selectedCountryId,
                                  );

                                  const managerOptions = country?.manager
                                    ? [
                                        {
                                          value: country.manager.id,
                                          label: country.manager.manager_name,
                                        },
                                      ]
                                    : [];
                                  return (
                                    <Form.Item
                                      {...restField}
                                      name={[name, "partner_company"]}
                                      label={t("Региональный представитель")}
                                      rules={[
                                        {
                                          required: true,
                                          message: t(
                                            "Выберите компанию партнера",
                                          ),
                                        },
                                      ]}
                                    >
                                      <Select
                                        className={s.select}
                                        placeholder={t("Компания")}
                                        options={managerOptions}
                                        onChange={() => {
                                          form.setFieldValue(
                                            ["routes", name, "service"],
                                            undefined,
                                          );
                                        }}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>
                            </Col>
                            <Col span={7}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.routes?.[name]?.transit_country !==
                                  currentValues.routes?.[name]?.transit_country
                                }
                              >
                                {({ getFieldValue }) => {
                                  const routes = (getFieldValue("routes") ||
                                    []) as any[];
                                  const route = routes[name];
                                  const selectedCountryId =
                                    route?.transit_country;
                                  const selectedCountry = countries?.find(
                                    (c) => c.id === selectedCountryId,
                                  );

                                  return (
                                    <Form.Item
                                      {...restField}
                                      name={[name, "entry_customs_checkpoint"]}
                                      label={t(
                                        "Въездной - Выездной таможенный пункт",
                                      )}
                                      rules={[
                                        {
                                          required: true,
                                          message: t(
                                            "Выберите въездной - выездной таможенный контрольно-пропускной пункт",
                                          ),
                                        },
                                      ]}
                                    >
                                      <Select
                                        popupClassName={"customSelectDropdown"}
                                        placeholder={t(
                                          "Въездной - Выездной таможенный пункт",
                                        )}
                                        className={s.select}
                                        options={selectedCountry?.bordered_countries.map(
                                          (it) => ({
                                            label: (
                                              <Divider
                                                plain
                                                orientation="center"
                                              >
                                                <span
                                                  className={
                                                    s.bordered_countries_names
                                                  }
                                                >
                                                  {it.bordered_country_names}
                                                </span>
                                              </Divider>
                                            ),
                                            title: it?.bordered_country_names,
                                            options: it.offices.map((el) => ({
                                              label: (
                                                <span className={s.post_name}>
                                                  {el.customs_name}
                                                </span>
                                              ),
                                              value: el.id,
                                            })),
                                          }),
                                        )}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>
                            </Col>
                            {/* <Col span={5}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.routes?.[name]?.transit_country !==
                                  currentValues.routes?.[name]?.transit_country
                                }
                              >
                                {({ getFieldValue }) => {
                                  const routes = (getFieldValue("routes") ||
                                    []) as any[];
                                  const route = routes[name];
                                  const selectedCountryId =
                                    route?.transit_country;
                                  const selectedCountry = countries?.find(
                                    (c) => c.id === selectedCountryId
                                  );

                                  return (
                                    <Form.Item
                                      {...restField}
                                      name={[name, "exit_customs_checkpoint"]}
                                      label="Выeздной таможенный пункт"
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Выберите въездной таможенный контрольно-пропускной пункт",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder={
                                          "Выездной таможенный контрольно - пропускной пункт"
                                        }
                                        className={s.select}
                                        popupClassName={"customSelectDropdown"}
                                        options={selectedCountry?.bordered_countries.map(
                                          (it) => ({
                                            label: (
                                              <Divider
                                                plain
                                                orientation="center"
                                              >
                                                <span
                                                  className={
                                                    s.bordered_countries_names
                                                  }
                                                >
                                                  {it.bordered_country_names}
                                                </span>
                                              </Divider>
                                            ),
                                            title: it?.bordered_country_names,
                                            options: it.offices.map((el) => ({
                                              label: (
                                                <span className={s.post_name}>
                                                  {el.customs_name}
                                                </span>
                                              ),
                                              value: el.id,
                                            })),
                                          })
                                        )}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>
                            </Col> */}

                            <Col span={9}>
                              <Form.Item
                                noStyle
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.routes?.[name]?.partner_company !==
                                  currentValues.routes?.[name]?.partner_company
                                }
                              >
                                {({ getFieldValue }) => {
                                  const routes = getFieldValue("routes") || [];
                                  const route = routes?.[name];
                                  const selectedCountryId =
                                    route?.transit_country;

                                  const selectedCompanyId =
                                    route?.partner_company;

                                  const country = managerServices?.find(
                                    (c) => c.id === selectedCountryId,
                                  );

                                  const allServices =
                                    country?.manager?.companies?.flatMap(
                                      (comp) =>
                                        comp.services.map((srv) => ({
                                          ...srv,
                                          company_name: comp.company_name,
                                        })),
                                    ) || [];

                                  return (
                                    <Form.Item
                                      {...restField}
                                      name={[name, "service"]}
                                      label={t("Услуги")}
                                      rules={[
                                        {
                                          required: true,
                                          message: t("Услуги"),
                                        },
                                      ]}
                                    >
                                      <Select
                                        className={s.service_select}
                                        mode="multiple"
                                        size={"middle"}
                                        allowClear
                                        placeholder={t("Услуги")}
                                        options={allServices.map((it) => ({
                                          value: it.id,
                                          label: `${it.price}$ — ${it.service_name} (${it.company_name})`,
                                        }))}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>
                            </Col>
                            {/* 
                            <Form.Item
                              label=" "
                              className={s.shipper_country}
                              name={[name, "is_destination"]}
                              valuePropName="checked"
                            >
                              <Checkbox
                                className="custom-checkbox"
                                // checked={route?.is_destination}
                                // onChange={() => {
                                //   const routes =
                                //     form.getFieldValue("routes") || [];
                                //   const updated = routes.map(
                                //     (r: any, i: number) => ({
                                //       ...r,
                                //       is_destination: i === name,
                                //     })
                                //   );
                                //   form.setFieldsValue({ routes: updated });
                                // }}
                                onChange={() => {
                                  const routes =
                                    form.getFieldValue("routes") || [];
                                  const index = Number(name);
                                  if (Number.isNaN(index)) return;
                                  const updated = routes.map(
                                    (r: any, i: number) => ({
                                      ...r,
                                      is_destination: i === index,
                                    })
                                  );
                                  form.setFieldsValue({ routes: updated });
                                }}
                              >
                                <Title level={5} className={s.checkbox}>
                                  Грузополучатель
                                </Title>
                              </Checkbox>
                            </Form.Item> */}

                            <Col className={s.btns_wrapper}>
                              <div className={s.btns_wrapper_inner}>
                                {fields.length > 1 && (
                                  <Tooltip
                                    placement="topRight"
                                    title={t("Удалить маршрут")}
                                    color={"gray"}
                                  >
                                    {!route?.is_destination && (
                                      <CloseCircleOutlined
                                        className={s.close_icon}
                                        onClick={() => {
                                          const routesBefore =
                                            form.getFieldValue("routes") || [];
                                          const isRemovedShipper =
                                            routesBefore?.[name]
                                              ?.is_destination;
                                          remove(name);
                                          Promise.resolve().then(() => {
                                            const updated =
                                              form.getFieldValue("routes") ||
                                              [];
                                            if (
                                              isRemovedShipper &&
                                              updated.length
                                            ) {
                                              const newRoutes = updated.map(
                                                (r: any, i: number) => ({
                                                  ...r,
                                                  is_destination:
                                                    i === updated.length - 1,
                                                }),
                                              );
                                              form.setFieldsValue({
                                                routes: newRoutes,
                                              });
                                            }
                                          });
                                        }}
                                      />
                                    )}
                                  </Tooltip>
                                )}
                                <Tooltip
                                  placement="topRight"
                                  title={t("Добавить транзитную страну")}
                                  color={"gray"}
                                >
                                  <PlusCircleOutlined
                                    className={s.plus_icon}
                                    onClick={() => addRouteRef.current?.()}
                                  />
                                </Tooltip>
                              </div>
                            </Col>
                          </div>
                        );
                      })}
                    </>
                  );
                }}
              </Form.List>
            </Row>

            <Row gutter={[12, 8]}>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="driver_name"
                  label={
                    width > 1091 ? t("ФИО (Водителя)") : t("ФИО (Водителя)")
                  }
                >
                  <Input
                    placeholder={t("ФИО (Водителя)")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_phone"
                  label={
                    width > 1091
                      ? t("Контактный телефон (Водителя)")
                      : t("Телефон (Водителя)")
                  }
                >
                  <PhoneInput
                    defaultCountry="md"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    className={s.phone_input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_email"
                  label={
                    width > 1091
                      ? t("Контактный Email (Водителя)")
                      : t("Email (Водителя)")
                  }
                >
                  <Input placeholder={t("Введите Email")} className={s.input} />
                </Form.Item>
              </Col>
            </Row>
            <h2 className={s.h2} style={{ width: "100%" }}>
              {t("Прикрепите документы")}
            </h2>
            <Table<UploadTableType>
              className="documents_table"
              columns={UploadTableColums}
              pagination={false}
              bordered
              dataSource={uploadTableData.map((it, index) => ({
                ...it,
                number: index + 1,
              }))}
            ></Table>

            <div className={s.btns}>
              <Button className={s.btn} htmlType="submit">
                {t("Зарегистрировать")}
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <Footer />
      {loading ? (
        <div className={s.loader}>
          <Loading loading={loading} />
        </div>
      ) : null}
    </div>
  );
};

export default CreateApplication2;
